export default {
  header: 'Preventas',
  navLink: '/app/preventas',
  children: []
}
